import { shape, string, number } from 'prop-types';

const imageType = shape({
  id: string.isRequired,
  name: string.isRequired,
  contentType: string.isRequired,
  size: number.isRequired,
  downloadUrl: string.isRequired,
  thumbnailUrl: string.isRequired
});

export default imageType;
